<template>
  <div>
    <Title>Reset your password</Title>
    <div v-if="uid && token">
      <PasswordResetForm :uid="uid" :token="token" />
    </div>
    <div v-else>
      <SubTitle>
        Enter your email and we'll send you a password reset link.
      </SubTitle>
      <v-form @submit.prevent="submit">
        <v-card width="400" class="mx-auto my-8">
          <v-card-title
            ><span class="headline">Password Reset</span></v-card-title
          >
          <v-card-text>
            <v-text-field
              required
              name="username"
              label="Email"
              type="email"
              v-model="email"
              prepend-icon="mdi-account-circle"
              :error="errors.email !== undefined"
              :error-messages="errors.email"
            />
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn type="submit" outlined color="success" class="mx-auto">
              <span>Do it</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </div>

    <v-snackbar v-model="snackbar.show" top>
      {{ snackbar.message }}
      <v-btn color="success" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import PasswordResetForm from "@/components/PasswordResetForm.vue";

export default {
  name: "UserAccount",
  components: { PasswordResetForm },
  props: {
    uid: { type: String },
    token: { type: String }
  },
  data() {
    return {
      email: "",
      errors: {},
      snackbar: { show: false, message: "" }
    };
  },
  methods: {
    ...mapActions("accounts", ["requestResetPassword"]),
    async submit() {
      this.errors = {};
      try {
        await this.requestResetPassword({ email: this.email });
        this.snackbar.message = "We've sent you a password reset email";
        this.snackbar.show = true;
      } catch (e) {
        this.errors = e.response.data;
      }
      console.log(this.email);
    }
  }
};
</script>
